package io.ktor.utils.io.core

/**
 * API marked with this annotation is experimental and could be changed
 */
@Suppress("DEPRECATION")
@RequiresOptIn(level = RequiresOptIn.Level.WARNING)
@Experimental(Experimental.Level.WARNING)
public annotation class ExperimentalIoApi
